import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=63fef53c&"
import script from "./JobDetail.vue?vue&type=script&lang=ts&"
export * from "./JobDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JobDetail.vue"
export default component.exports